import React, { useState, useEffect, useCallback, useRef } from 'react';
import { FaTimes, FaChevronLeft, FaChevronRight } from 'react-icons/fa';

const ItineraryGallery = ({
  galleryImages,
  isModalOpen,
  selectedImageIndex,
  openModal,
  closeModal,
  showNextImage,
  showPrevImage
}) => {
  const [mobileActiveIndex, setMobileActiveIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);
  
  const modalRef = useRef(null);

  // Placeholder images when no real images are available
  const placeholderImages = [
    {
      src: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODAwIiBoZWlnaHQ9IjYwMCIgdmlld0JveD0iMCAwIDgwMCA2MDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSI4MDAiIGhlaWdodD0iNjAwIiBmaWxsPSIjMzMzIi8+CjxwYXRoIGQ9Ik0zNzUgMjI1SDQyNVYyNzVIMzc1VjIyNVoiIGZpbGw9IiM2NjYiLz4KPHN2ZyB4PSIzNDAiIHk9IjI4MCIgd2lkdGg9IjEyMCIgaGVpZ2h0PSI4MCI+CjxwYXRoIGQ9Ik0wIDQwTDIwIDIwTDQwIDQwTDYwIDIwTDgwIDQwTDEwMCAyMEwxMjAgNDBWODBIMFY0MFoiIGZpbGw9IiM2NjYiLz4KPC9zdmc+Cg==',
      alt: 'No image available'
    },
    {
      src: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODAwIiBoZWlnaHQ9IjYwMCIgdmlld0JveD0iMCAwIDgwMCA2MDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSI4MDAiIGhlaWdodD0iNjAwIiBmaWxsPSIjMzMzIi8+CjxwYXRoIGQ9Ik0zNzUgMjI1SDQyNVYyNzVIMzc1VjIyNVoiIGZpbGw9IiM2NjYiLz4KPHN2ZyB4PSIzNDAiIHk9IjI4MCIgd2lkdGg9IjEyMCIgaGVpZ2h0PSI4MCI+CjxwYXRoIGQ9Ik0wIDQwTDIwIDIwTDQwIDQwTDYwIDIwTDgwIDQwTDEwMCAyMEwxMjAgNDBWODBIMFY0MFoiIGZpbGw9IiM2NjYiLz4KPC9zdmc+Cg==',
      alt: 'No image available'
    },
    {
      src: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODAwIiBoZWlnaHQ9IjYwMCIgdmlld0JveD0iMCAwIDgwMCA2MDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSI4MDAiIGhlaWdodD0iNjAwIiBmaWxsPSIjMzMzIi8+CjxwYXRoIGQ9Ik0zNzUgMjI1SDQyNVYyNzVIMzc1VjIyNVoiIGZpbGw9IiM2NjYiLz4KPHN2ZyB4PSIzNDAiIHk9IjI4MCIgd2lkdGg9IjEyMCIgaGVpZ2h0PSI4MCI+CjxwYXRoIGQ9Ik0wIDQwTDIwIDIwTDQwIDQwTDYwIDIwTDgwIDQwTDEwMCAyMEwxMjAgNDBWODBIMFY0MFoiIGZpbGw9IiM2NjYiLz4KPC9zdmc+Cg==',
      alt: 'No image available'
    },
    {
      src: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODAwIiBoZWlnaHQ9IjYwMCIgdmlld0JveD0iMCAwIDgwMCA2MDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSI4MDAiIGhlaWdodD0iNjAwIiBmaWxsPSIjMzMzIi8+CjxwYXRoIGQ9Ik0zNzUgMjI1SDQyNVYyNzVIMzc1VjIyNVoiIGZpbGw9IiM2NjYiLz4KPHN2ZyB4PSIzNDAiIHk9IjI4MCIgd2lkdGg9IjEyMCIgaGVpZ2h0PSI4MCI+CjxwYXRoIGQ9Ik0wIDQwTDIwIDIwTDQwIDQwTDYwIDIwTDgwIDQwTDEwMCAyMEwxMjAgNDBWODBIMFY0MFoiIGZpbGw9IiM2NjYiLz4KPC9zdmc+Cg==',
      alt: 'No image available'
    }
  ];

  // Use placeholder images if no real images are provided
  const displayImages = (!galleryImages || galleryImages.length === 0) ? placeholderImages : galleryImages;

  // Handle keyboard navigation
  const handleKeyDown = useCallback((e) => {
    if (!isModalOpen) return;
    
    switch(e.key) {
      case 'ArrowRight':
        showNextImage();
        break;
      case 'ArrowLeft':
        showPrevImage();
        break;
      case 'Escape':
        closeModal();
        break;
      default:
        break;
    }
  }, [isModalOpen, showNextImage, showPrevImage, closeModal]);

  // Set up event listeners for keyboard navigation
  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleKeyDown]);

  // Handle touch events for swipe
  const handleTouchStart = (e) => {
    setTouchStart(e.targetTouches[0].clientX);
  };
  
  const handleTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };
  
  const handleTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > 50;
    const isRightSwipe = distance < -50;
    
    if (isLeftSwipe && !isTransitioning) {
      setIsTransitioning(true);
      showNextImage();
      setTimeout(() => setIsTransitioning(false), 300);
    }
    
    if (isRightSwipe && !isTransitioning) {
      setIsTransitioning(true);
      showPrevImage();
      setTimeout(() => setIsTransitioning(false), 300);
    }
    
    setTouchStart(null);
    setTouchEnd(null);
  };

  const handleMobileThumbClick = (index) => {
    setMobileActiveIndex(index);
  };

  return (
    <>
      <div
        className="itinerary-gallery"
        style={{ marginTop: '3rem' }}
      >
        {/* Desktop gallery layout */}
        <div className="gallery-thumbnails desktop-gallery gallery-desktop-custom">
          {/* Featured big image */}
          <div
            className="gallery-thumbnail gallery-thumbnail-featured"
            onClick={() => openModal(0)}
            tabIndex={0}
            aria-label={`View image 1 of ${displayImages.length}: ${displayImages[0].alt || 'Tour image'}`}
            role="button"
            onKeyDown={(e) => e.key === 'Enter' && openModal(0)}
          >
            <img
              src={displayImages[0].src.replace('800x600', '800x600')}
              alt={displayImages[0].alt || `Tour image 1`}
              loading="eager"
            />
          </div>
          {/* 2x2 grid for next 4 images */}
          <div className="gallery-thumbnails-grid">
            {[1,2,3,4].map(idx => (
              displayImages[idx] ? (
                <div
                  key={idx}
                  className="gallery-thumbnail"
                  onClick={() => openModal(idx)}
                  tabIndex={0}
                  aria-label={`View image ${idx + 1} of ${displayImages.length}: ${displayImages[idx].alt || 'Tour image'}`}
                  role="button"
                  onKeyDown={(e) => e.key === 'Enter' && openModal(idx)}
                >
                  <img
                    src={displayImages[idx].src.replace('800x600', '400x300')}
                    alt={displayImages[idx].alt || `Tour image ${idx + 1}`}
                    loading="eager"
                  />
                </div>
              ) : null
            ))}
          </div>
        </div>

        {/* Mobile gallery layout */}
        <div className="mobile-gallery">
          <div 
            className="gallery-mobile-main" 
            onClick={() => openModal(mobileActiveIndex)}
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleTouchEnd}
          >
            <img 
              src={displayImages[mobileActiveIndex].src} 
              alt={displayImages[mobileActiveIndex].alt || `Tour image ${mobileActiveIndex + 1}`} 
              loading="eager"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                display: 'block',
                position: 'absolute',
                top: 0,
                left: 0
              }}
            />
          </div>
          <div className="gallery-mobile-thumbs-row">
            {displayImages.slice(0, 5).map((image, index) => (
              <div 
                key={index}
                className={`gallery-mobile-thumb ${mobileActiveIndex === index ? 'selected' : ''}`}
                onClick={(e) => {
                  e.stopPropagation();
                  handleMobileThumbClick(index);
                }}
              >
                <img 
                  src={image.src.replace('800x600', '150x150')} 
                  alt={image.alt || `Thumbnail ${index + 1}`} 
                  loading="lazy" 
                />
              </div>
            ))}
            {displayImages.length > 5 && (
              <div 
                className="gallery-mobile-thumb more"
                onClick={(e) => {
                  e.stopPropagation();
                  openModal(5);
                }}
              >
                +{displayImages.length - 5}
              </div>
            )}
          </div>
        </div>
      </div>

      {isModalOpen && (
        <div 
          className="gallery-modal" 
          onClick={closeModal}
          ref={modalRef}
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
        >
          <button className="close-modal" onClick={closeModal} aria-label="Close image gallery">
            <FaTimes />
          </button>
          <button className="prev-btn" onClick={showPrevImage} aria-label="Previous image">
            <FaChevronLeft />
          </button>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <img 
              src={displayImages[selectedImageIndex].src} 
              alt={displayImages[selectedImageIndex].alt || `Image ${selectedImageIndex + 1}`} 
              className="modal-image" 
            />
          </div>
          <button className="next-btn" onClick={showNextImage} aria-label="Next image">
            <FaChevronRight />
          </button>
          <div className="modal-counter">
            {selectedImageIndex + 1} / {displayImages.length}
          </div>
        </div>
      )}
    </>
  );
};

export default ItineraryGallery;
